import React from 'react';
import Layout from '../components/Layout';
import { Building, Mail, Phone, Globe } from 'lucide-react';

const Impressum = ({ user }) => {
  return (
    <Layout user={user}>
      <div className="max-w-4xl mx-auto p-4 md:p-8">
        <div className="bg-white rounded-lg shadow-sm border" style={{borderColor: '#E1E4E8'}}>
          <div className="p-6 md:p-8">
            <h1 className="text-3xl font-bold text-gray-900 mb-6">Impressum</h1>
            
            <div className="space-y-6">
              <div>
                <h2 className="text-xl font-semibold text-gray-900 mb-3 flex items-center gap-2">
                  <Building className="w-5 h-5 text-blue-600" />
                  Angaben gemäß § 5 TMG
                </h2>
                <div className="text-gray-700 space-y-1">
                  <p className="font-medium">Easyclaim24 GmbH</p>
                  <p>Musterstraße 123</p>
                  <p>12345 Musterstadt</p>
                  <p>Deutschland</p>
                </div>
              </div>

              <div className="border-t pt-6" style={{borderColor: '#E1E4E8'}}>
                <h2 className="text-xl font-semibold text-gray-900 mb-3">Vertreten durch</h2>
                <p className="text-gray-700">Geschäftsführer: Max Mustermann</p>
              </div>

              <div className="border-t pt-6" style={{borderColor: '#E1E4E8'}}>
                <h2 className="text-xl font-semibold text-gray-900 mb-3">Kontakt</h2>
                <div className="space-y-2">
                  <div className="flex items-center gap-3 text-gray-700">
                    <Phone className="w-4 h-4 text-blue-600" />
                    <span>+49 (0) 123 456789</span>
                  </div>
                  <div className="flex items-center gap-3 text-gray-700">
                    <Mail className="w-4 h-4 text-blue-600" />
                    <a href="mailto:info@easyclaim24.de" className="text-blue-600 hover:underline">info@easyclaim24.de</a>
                  </div>
                  <div className="flex items-center gap-3 text-gray-700">
                    <Globe className="w-4 h-4 text-blue-600" />
                    <a href="https://www.easyclaim24.de" className="text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer">www.easyclaim24.de</a>
                  </div>
                </div>
              </div>

              <div className="border-t pt-6" style={{borderColor: '#E1E4E8'}}>
                <h2 className="text-xl font-semibold text-gray-900 mb-3">Registereintrag</h2>
                <div className="text-gray-700 space-y-1">
                  <p>Eintragung im Handelsregister</p>
                  <p>Registergericht: Amtsgericht Musterstadt</p>
                  <p>Registernummer: HRB 12345</p>
                </div>
              </div>

              <div className="border-t pt-6" style={{borderColor: '#E1E4E8'}}>
                <h2 className="text-xl font-semibold text-gray-900 mb-3">Umsatzsteuer-ID</h2>
                <p className="text-gray-700">Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz: DE123456789</p>
              </div>

              <div className="border-t pt-6" style={{borderColor: '#E1E4E8'}}>
                <h2 className="text-xl font-semibold text-gray-900 mb-3">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
                <div className="text-gray-700 space-y-1">
                  <p>Max Mustermann</p>
                  <p>Musterstraße 123</p>
                  <p>12345 Musterstadt</p>
                </div>
              </div>

              <div className="border-t pt-6" style={{borderColor: '#E1E4E8'}}>
                <h2 className="text-xl font-semibold text-gray-900 mb-3">Haftungsausschluss</h2>
                <div className="text-gray-700 space-y-4">
                  <div>
                    <h3 className="font-semibold mb-2">Haftung für Inhalte</h3>
                    <p className="text-sm leading-relaxed">Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.</p>
                  </div>
                  <div>
                    <h3 className="font-semibold mb-2">Haftung für Links</h3>
                    <p className="text-sm leading-relaxed">Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.</p>
                  </div>
                  <div>
                    <h3 className="font-semibold mb-2">Urheberrecht</h3>
                    <p className="text-sm leading-relaxed">Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Impressum;
